import React from 'react';
import { Button } from 'antd';
import { RocketOutlined } from '@ant-design/icons';

import useSdkSetupHandoff from '@Utils/useSdkSetupHandoff';

import style from './SdkSetupPagePromo.module.less';

export default function SdkSetupPagePromo({ productId, currentUser }) {
  const { loading, sdkReady, onSetupNow } = useSdkSetupHandoff({
    productId,
    currentUser,
    enabled: Boolean(productId),
  });

  if (!productId) {
    return null;
  }

  return (
    <div className={style.promo}>
      <RocketOutlined className={style.icon} aria-hidden />
      <span className={style.title}>Guided SDK setup</span>
      <span className={style.badge}>~29 min</span>
      <Button
        type="primary"
        size="small"
        className={style.cta}
        loading={loading}
        disabled={loading || !sdkReady}
        onClick={onSetupNow}
      >
        Setup now
      </Button>
    </div>
  );
}
